import axios from 'axios';
import { loginRequest } from './authConfig';
import { msalInstance } from './msalInstance';

const apiUrl = (process.env.REACT_APP_API_URL || 'https://localhost:7289')
  .replace(/\/+$/, '');

const instance = axios.create({
  baseURL: apiUrl,
});

instance.interceptors.request.use(async (config) => {
  const account = msalInstance.getActiveAccount()
    || msalInstance.getAllAccounts()[0];

  if (!account) {
    return config;
  }

  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
  });

  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${response.accessToken}`;

  return config;
});

export default instance;
